import React from 'react';

import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';

export default class Message extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      message: this.props.message,
      title: this.props.title,
      hidden: true
    }
  }

  show = ( message = 'Error ´no identificado', title = 'Error al realizar la operación' ) => {
    this.setState({
      message: message,
      title: title,
      hidden: false
    });
  }

  render() {
    return (
      <Dialog
          hidden={ this.state.hidden }
          onDismiss={ () => this.setState({ hidden: true }) }
          dialogContentProps={{
            type: DialogType.normal,
            title: this.state.title,
            subText: this.state.message
          }}
          modalProps={{
            isBlocking: false,
            containerClassName: 'ms-dialogMainOverride'
          }}
        >
          <DialogFooter>
            <DefaultButton onClick={ () => this.setState({ hidden: true }) } text="Entendido" />
          </DialogFooter>
        </Dialog>
    )
  }
}


// WEBPACK FOOTER //
// ./src/component/Message.jsx